<template>
    <div>
        <div class="row" v-if="course" @click="more()">

            <div class="col-3 course-logo-link-div">
                <router-link
                        :disabled="course.notforsale"
                        :event="course.notforsale ? '' : 'click'"
                        :to="{ name: 'course.details', params: { slug: course.slug }}">
                    <img
                            class="home-kurs-img lazyloaded"
                            style="max-width: 100%;"
                            v-if="course.caticon"
                            :src="course.caticon"
                    >

                    <img
                            class="home-kurs-img lazyloaded"
                            style="max-width: 100%;"
                            src="@/assets/hometeacher/images/home-kurs-none.png"
                            v-else
                    >
                </router-link>
            </div>
            <div class="col-9 pl-0">
                <div class="course-present-name pb-2">
                    <router-link
                            :disabled="course.notforsale"
                            :event="course.notforsale ? '' : 'click'"
                            :to="{ name: 'course.details', params: { slug: course.slug }}">
                        {{course.course}}
                    </router-link>
                    <img class="" :src="require(`@/assets/hometeacher/images/${difficlty}.png`)">
                </div>
                <div class="course-present-details">
                    <span v-if="languageText">{{ $t('language') }}: <span class="strong-black">{{ languageText }}</span></span>
                    <span v-if="ageText">, {{ $t('age') }}: <span class="strong-black">{{ ageText }}</span></span>
                    <span v-if="course.lessonscount">, {{ $t('lessons') }}: <span class="strong-black">{{ course.lessonscount }}</span></span>
                    <span v-if="course.duration">, {{ $t('lesson_duration') }}: <span
                            class="strong-black">{{ course.duration }}</span></span>
                    <span v-if="course.duration_course">, {{ $t('course_duration') }}: <span class="strong-black">{{ course.duration_course }}</span>
                        </span>
                </div>

            </div>
        </div>
        <div class="row" v-if="!lastItem">
            <div class="col-12">
                <div class="land-t-delimeter mt-3 mb-3"></div>
            </div>
        </div>
    </div>
</template>

<script>


    import courseApi from "../../../data/CourseApi";

    export default {
        name: "CoursePresentListItem",
        props: {
            title: String,
            course: {
                type: Object,
            },
            lastItem: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {}
        },

        mounted() {

        },

        computed: {
            ageText() {
                if (this.course.ages && this.course.ages.length > 0) {
                    let ages = []
                    for (let age of this.course.ages) {
                        ages.push(courseApi.getAgeName(age.idage))
                    }
                    return ages.join(", ")
                }
                return courseApi.getAllAgeNames();
            },

            languageText() {
                if (this.course.idlanguage) return courseApi.getLanguageName(this.course.idlanguage)
                return "-";
            },

            difficlty() {
                if (this.course.difficulty) return courseApi.getDifficultyName(this.course.difficulty).toLowerCase()
                return "easy";
            },

        },

        methods: {
            more() {
                if (this.course.notforsale) return
                this.$emit('more', this.course)
            },
        },
    }
</script>

<style scoped>
    .easy {
        display: inline;
    }

    .course-present-name a {
        font-family: "Manrope Bold";
        color: #231c37;
        font-size: 18px;
        border-bottom: 1px solid #d7e1e5;
    }

    .course-logo-link {
        display: inline-block;
    }

    .course-logo-link-div {
        text-align: center;
    }

    .course-present-details {
        font-family: "Manrope Light";
        color: #8b8496;
        font-size: 15px;
        line-height: 21px;
    }

    @media (max-width: 580px) {
        .easy {
            margin: 0 auto;
        }
    }
</style>

<style src="@/assets/hometeacher/css/main.css">
</style>
